"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROW_HEIGHT = void 0;
// @ts-nocheck
const react_1 = __importDefault(require("react"));
const getterUtils_1 = require("../getterUtils");
const core_1 = require("@material-ui/core");
const NoAnimationRadio_1 = __importDefault(require("../NoAnimationRadio"));
exports.ROW_HEIGHT = 35;
const RowRenderer = (props) => {
    const { generalProps, state, setState, refresh, style } = props;
    const classes = useStyles();
    const multiSelect = generalProps === null || generalProps === void 0 ? void 0 : generalProps.multiSelect;
    const isOptionSelected = (option) => {
        return !!state.find((value) => getterUtils_1.areOptionsEqual(value, option, generalProps === null || generalProps === void 0 ? void 0 : generalProps.pathToValue));
    };
    const onChange = (option) => {
        const newState = (() => {
            if (multiSelect) {
                const isChecked = isOptionSelected(option);
                if (!isChecked) {
                    return [...state, option];
                }
                else {
                    return state.filter((value) => !getterUtils_1.areOptionsEqual(value, option, generalProps === null || generalProps === void 0 ? void 0 : generalProps.pathToValue));
                }
            }
            else {
                return [option];
            }
        })();
        refresh();
        setState(newState);
    };
    const option = props.row;
    if (option === undefined) {
        return (react_1.default.createElement(core_1.ListItem, null,
            react_1.default.createElement(core_1.Typography, null, "undefined")));
    }
    const control = multiSelect ? (react_1.default.createElement(core_1.Checkbox, { checked: isOptionSelected(option), onChange: () => onChange(option), color: "primary" })) : (react_1.default.createElement(NoAnimationRadio_1.default, { checked: isOptionSelected(option), onClick: () => onChange(option) }));
    return (react_1.default.createElement(core_1.ListItem, { dense: true, className: classes.item, style: style },
        react_1.default.createElement(core_1.FormControlLabel, { className: classes.item, classes: { label: classes.label }, value: getterUtils_1.getValue(option, generalProps === null || generalProps === void 0 ? void 0 : generalProps.pathToValue), control: control, label: getterUtils_1.getLabel(option, generalProps === null || generalProps === void 0 ? void 0 : generalProps.pathToLabel) })));
};
const useStyles = core_1.makeStyles(() => ({
    item: {
        height: exports.ROW_HEIGHT,
    },
    label: {
        lineHeight: '16px',
        fontSize: 16,
    },
}));
exports.default = RowRenderer;
//# sourceMappingURL=TGOptionModalRowRenderer.js.map